import React from "react";
import { useNavigate } from "react-router";
import styled from "styled-components";
import { RaffleRow, NameWithModel, NameDetails, RaffleType, PrizeCell } from "./RaffleList.styles";
import RaffleTypeModel from "./RaffleTypeModel";

// Misma fila que Sorteos y Torneos: modelo animado + nombre a la izquierda y la cantidad de pozos a la derecha.
const ProgressiveRow = styled(RaffleRow)`
  grid-template-columns: minmax(0, 1fr) fit-content(30%);
  @media (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr) fit-content(40%);
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;
const LevelsCell = styled(PrizeCell)`
  border-left: 1px solid #d5ab4f66;
  margin: 22px 0;
  padding: 12px clamp(20px, 3vw, 56px);
  @media (max-width: 480px) {
    border-left: 0;
    border-top: 1px solid #d5ab4f66;
    margin: 0 16px 8px;
  }
`;

export default function CardProgressive({ item }) {
  const { id, name: promoName, levels } = item;
  const navigate = useNavigate();

  return (
    <ProgressiveRow type="button" data-testid="progressive-row" onClick={() => navigate("/progressive-view/" + id)}>
      <NameWithModel>
        <RaffleTypeModel kind="trophy" />
        <NameDetails>
          <RaffleType>PROGRESIVO</RaffleType>
          <span>{promoName}</span>
        </NameDetails>
      </NameWithModel>
      <LevelsCell>
        <RaffleType>POZOS</RaffleType>
        <span>{levels?.length ?? 0}</span>
      </LevelsCell>
    </ProgressiveRow>
  );
}
